import React from "react"

import LpHighLevelKpisAndHighlightsChart from "@/QuarterlyReport/charts/LpHighLevelKpisAndHighlightsChart"

const EmptyChart = () => {
  return (
    <div
      style={{
        padding: "20px",
        textAlign: "center",
        color: "#666",
        fontStyle: "italic",
        border: "1px dashed #ccc",
        borderRadius: "4px",
        margin: "10px 0",
      }}
    >
      No chart data available
    </div>
  )
}

// Helper function to determine if we have valid chart data
const hasValidChartData = (data: any) => {
  return data && Array.isArray(data) && data.length > 0
}

export class IRRSeriesChartTool {
  api: any
  block: any
  createPortal: any
  removePortal: any
  portal: any
  irrSeriesData: any

  constructor(config: any) {
    this.block = config.block
    this.api = config.api
    this.createPortal = config.config?.createPortal
    this.removePortal = config.config?.removePortal
    this.irrSeriesData = config.config?.irrSeriesData
    return this
  }

  static get toolbox() {
    return {
      title: "IRR Series Chart",
      icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3v18h18"/><path d="m19 9-5 5-4-4-3 3"/></svg>',
    }
  }

  render() {
    const rootEl = document.createElement("div")

    const hasData = hasValidChartData(this.irrSeriesData)

    this.portal = this.createPortal(
      this.block.id,
      hasData ? (
        <LpHighLevelKpisAndHighlightsChart
          data={{
            series: this.irrSeriesData,
          }}
        />
      ) : (
        <EmptyChart />
      ),
      rootEl,
    )

    return rootEl
  }

  remove() {
    const totalBlocks = this.api.blocks.getBlocksCount()
    for (let i = 0; i < totalBlocks; i++) {
      const block = this.api.blocks.getBlockByIndex(i)
      if (block && block.id === this.block.id) {
        this.api.blocks.delete(i)
        break
      }
    }
  }

  removed() {
    this.removePortal(this.block.id)
  }

  save() {
    return {
      type: "irr_series_chart",
    }
  }

  static get isReadOnlySupported() {
    return true
  }
}
